import React, { useEffect, useState } from "react";
import "./Saved_Address.css";
import { useNavigate } from "react-router-dom";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOrderAddress,
  getAllOrderAddressBilling,
} from "../../../features/order/orderSlice";
import { deleteUserAddress } from "../../../features/user/userSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const Saved_Address = () => {
  const navigate = useNavigate();
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [orderAddress, setOrderAddress] = useState({});
  const [addressId, setAddressId] = useState(null);
  const [addressBillingId, setAddressBillingId] = useState(null);
  const [orderBillingAddress, setOrderBillingAddress] = useState({});

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      DELETE ADDRESS
    </Tooltip>
  );

  const dispatch = useDispatch();
  const allAddress = useSelector((state) => state.order.allOrdersAddress);
  const allBillingAddress = useSelector(
    (state) => state.order.allBillingAddress,
  );

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    // if (user?.id) {
    dispatch(getAllOrderAddress());
    dispatch(getAllOrderAddressBilling());
    // }
  }, []);

  const handleDelete = async (id) => {
    const res = await dispatch(deleteUserAddress(id));
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllOrderAddress());
      await dispatch(getAllOrderAddressBilling());
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  useEffect(() => {
    if (allAddress?.data?.length > 0) {
      setAddressId(allAddress.data[0].id);
    }

    if (allBillingAddress?.data?.length > 0) {
      setAddressBillingId(allBillingAddress.data[0].id);
    }
  }, [allAddress]);

  return (
    <section className="Saved_Address Personal_Info">
      <div className="addres_card_holder">
        <div className="row">
          {allAddress?.data?.map((address, index) => {
            const parts = [
              address?.flour,
              address?.building,
              address?.street,
              address?.area,
              address?.apartment,
              address?.direction,
              address?.Users_Address_Detail?.Country?.name,
              address?.Users_Address_Detail?.State?.name,
              address?.Users_Address_Detail?.City?.name,
              address?.Users_Address_Detail?.Pincode?.name,
            ];
            return (
              <div
                className="col-lg-6 col-md-12 col-sm-6 col-12 mb-3"
                key={address?.id || index}
              >
                <div
                  className="address_card"
                  onClick={() => {
                    setOrderAddress(address);
                    setAddressId(address?.id);
                  }}
                >
                  <div className="top_address_heading">
                    <div className="heading">
                      <p>{address?.User_Address_Type?.name}</p>
                    </div>

                    <div className="form-holder">
                      <Form.Check
                        type="radio"
                        id={address?.id}
                        checked={addressId === address?.id}
                      />
                    </div>
                  </div>

                  <div className="user_address">
                    <div>
                      <p className="user_name">
                        {address?.User?.name}
                        {"    "}
                        {address?.User?.last_name}
                      </p>
                    </div>

                    <div>
                      <p className="contact_no">{address?.contact_no}</p>
                    </div>

                    <div className="footer_div">
                      <div className="address_div">
                        <p>{parts.filter(Boolean).join(", ")}</p>
                      </div>
                    </div>
                  </div>

<div className="edit_delete_holder">

                  <div
                    className="edit_btn_div"
                    onClick={() => {
                      setAddressId(address?.id);
                    }}
                  >
                    <p
                      onClick={() => {
                        navigate(`/edit-new-address/${address?.id}`);
                      }}
                    >
                      Edit
                    </p>
                  </div>

                  <div
                    className="delete_icon_holder"
                    onClick={() => {
                      handleDelete(address?.id);
                    }}
                  >
                    <OverlayTrigger
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <FontAwesomeIcon icon={faTrash} className="delete_icon" />
                    </OverlayTrigger>
                  </div>
                  </div>
                </div>
              </div>
            );
          })}
          {allBillingAddress?.data?.map((address, index) => {
            const parts = [
              address?.flour,
              address?.building,
              address?.street,
              address?.area,
              address?.apartment,
              address?.direction,
              address?.Users_Address_Detail?.Country?.name,
              address?.Users_Address_Detail?.State?.name,
              address?.Users_Address_Detail?.City?.name,
              address?.Users_Address_Detail?.Pincode?.name,
            ];
            return (
              <div
                className="col-lg-6 col-md-12 col-sm-6 col-12 mb-3"
                key={address?.id || index}
              >
                <div
                  className="address_card"
                  onClick={() => {
                    setOrderBillingAddress(address);
                    setAddressBillingId(address?.id);
                  }}
                >
                  <div className="top_address_heading">
                    <div className="heading">
                      <p>{address?.User_Address_Type?.name}</p>
                    </div>

                    <div className="form-holder">
                      <Form.Check
                        type="radio"
                        id={`billing-${address?.id}`}
                        checked={addressBillingId === address?.id}
                        onChange={() => {
                          setOrderBillingAddress(address);
                          setAddressBillingId(address?.id);
                        }}
                      />
                    </div>
                  </div>

                  <div className="user_address">
                    <div>
                      <p className="user_name">
                        {address?.User?.name}
                        {"    "}
                        {address?.User?.last_name}
                      </p>
                    </div>

                    <div>
                      <p className="contact_no">{address?.contact_no}</p>
                    </div>

                    <div className="footer_div">
                      <div className="address_div">
                        <p>{parts.filter(Boolean).join(", ")}</p>
                      </div>
                    </div>
                  </div>
<div className="edit_delete_holder">
                  <div
                    className="edit_btn_div"
                    onClick={() => {
                      setAddressBillingId(address?.id);
                    }}
                  >
                    <p
                      onClick={() => {
                        navigate(`/edit-new-address/${address?.id}`);
                      }}
                    >
                      Edit
                    </p>
                  </div>

                  <div
                    className="delete_icon_holder"
                    onClick={() => {
                      handleDelete(address?.id);
                    }}
                  >
                    <OverlayTrigger
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <FontAwesomeIcon icon={faTrash} className="delete_icon" />
                    </OverlayTrigger>
                  </div>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-3">
            <div
              className="address_card last_card"
              onClick={() => {
                navigate("/add-new-address");
              }}
            >
              <div className="img_holder">
                <img
                  src="/assets/images/icons/address.png"
                  className="address_img"
                />
              </div>
              <p className="bottom_text">Add New Address</p>
            </div>
          </div>
        </div>
      </div>

      {/* <Your_Location_Info_Modal
        current_location={current_location}
        btnText="Enter Complete Address"
        show={showModal}
        onHide={() => setShowModal(false)}
        orange_btn_text={"Enter Address"}
        green_btn_text={"Verify Address"}
        showText={false}
        modalTitle="Your Location Info"
      /> */}
    </section>
  );
};

export default Saved_Address;
